import { jsx as a, jsxs as l, Fragment as h } from "react/jsx-runtime";
import { useState as v } from "react";
const c = {
  glowColor: "rgba(99, 102, 241, 0.18)",
  accentColor: "#2563eb",
  accentHoverColor: "#1d4ed8"
};
function x({
  theme: n,
  background: e = !0,
  className: s,
  children: r
}) {
  const o = (n == null ? void 0 : n.accentColor) ?? c.accentColor, i = (n == null ? void 0 : n.accentHoverColor) ?? (n == null ? void 0 : n.accentColor) ?? c.accentHoverColor, t = {
    "--ds-glow": (n == null ? void 0 : n.glowColor) ?? c.glowColor,
    "--ds-accent": o,
    "--ds-accent-hover": i
  };
  return /* @__PURE__ */ a(
    "div",
    {
      "data-ds-root": !0,
      "data-ds-background": e ? "true" : "false",
      className: s,
      style: t,
      children: r
    }
  );
}
function f(n) {
  var e, s;
  return (((e = n.given_name) == null ? void 0 : e[0]) || ((s = n.email) == null ? void 0 : s[0]) || "U").toUpperCase();
}
function N(n) {
  return n.given_name ? n.family_name ? `${n.given_name} ${n.family_name}` : n.given_name : n.email || "User";
}
function C({ user: n, onLogout: e }) {
  const [s, r] = v(!1), o = N(n);
  return /* @__PURE__ */ l("div", { className: "ds-usermenu", children: [
    /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        className: "ds-usermenu-trigger",
        onClick: () => r((i) => !i),
        "aria-haspopup": "menu",
        "aria-expanded": s,
        children: [
          /* @__PURE__ */ a("div", { className: "ds-usermenu-avatar", children: f(n) }),
          /* @__PURE__ */ a("span", { className: "ds-usermenu-name", children: o })
        ]
      }
    ),
    s ? /* @__PURE__ */ l(h, { children: [
      /* @__PURE__ */ a("div", { className: "ds-usermenu-backdrop", onClick: () => r(!1) }),
      /* @__PURE__ */ l("div", { className: "ds-usermenu-panel", role: "menu", children: [
        /* @__PURE__ */ l("div", { className: "ds-usermenu-header", children: [
          /* @__PURE__ */ a("div", { className: "ds-usermenu-header-name", children: o }),
          n.email ? /* @__PURE__ */ a("div", { className: "ds-usermenu-header-email", children: n.email }) : null
        ] }),
        e ? /* @__PURE__ */ l(
          "button",
          {
            type: "button",
            className: "ds-usermenu-item ds-usermenu-item-danger",
            onClick: () => {
              r(!1), e();
            },
            children: [
              /* @__PURE__ */ l(
                "svg",
                {
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  "aria-hidden": "true",
                  children: [
                    /* @__PURE__ */ a("path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }),
                    /* @__PURE__ */ a("polyline", { points: "16 17 21 12 16 7" }),
                    /* @__PURE__ */ a("line", { x1: "21", y1: "12", x2: "9", y2: "12" })
                  ]
                }
              ),
              "Sign out"
            ]
          }
        ) : null
      ] })
    ] }) : null
  ] });
}
function U({
  appName: n,
  appShortName: e,
  showPortalLink: s,
  nav: r,
  actions: o,
  searchPlaceholder: i,
  onSearch: d,
  user: t,
  onLogout: p
}) {
  const m = !!(i || d), b = e ?? n.slice(0, 2).toUpperCase();
  return /* @__PURE__ */ a("div", { className: "ds-topbar-wrap", children: /* @__PURE__ */ l("div", { className: "ds-topbar", children: [
    /* @__PURE__ */ l("a", { className: "ds-topbar-brand", href: s ? "https://portal.neutheria.ch" : "/", children: [
      /* @__PURE__ */ a("span", { className: "ds-topbar-brand-prefix ds-topbar-brand-prefix-full", children: "Neutheria " }),
      /* @__PURE__ */ a("span", { className: "ds-topbar-brand-prefix ds-topbar-brand-prefix-short", children: "N" }),
      /* @__PURE__ */ a("span", { className: "ds-topbar-brand-full", children: n }),
      /* @__PURE__ */ a("span", { className: "ds-topbar-brand-short", children: b })
    ] }),
    m ? /* @__PURE__ */ a("div", { className: "ds-topbar-search", children: /* @__PURE__ */ a(
      "input",
      {
        type: "search",
        placeholder: i ?? "Search...",
        onChange: (g) => d == null ? void 0 : d(g.target.value)
      }
    ) }) : null,
    r ? /* @__PURE__ */ a("div", { className: "ds-topbar-slot", children: r }) : null,
    /* @__PURE__ */ l("div", { className: "ds-topbar-slot", style: { marginLeft: "auto" }, children: [
      o,
      t ? /* @__PURE__ */ a(C, { user: t, onLogout: p }) : null
    ] })
  ] }) });
}
const y = {
  primary: "ds-btn-primary",
  secondary: "ds-btn-secondary",
  ghost: "ds-btn-ghost",
  danger: "ds-btn-danger"
};
function u({
  variant: n = "primary",
  block: e = !1,
  className: s,
  children: r,
  type: o = "button",
  ...i
}) {
  const d = [
    "ds-btn",
    y[n],
    e ? "ds-btn-block" : "",
    s ?? ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ a("button", { type: o, className: d, ...i, children: r });
}
function _({ appName: n, tagline: e, onLogin: s, onRegister: r }) {
  return /* @__PURE__ */ a("div", { className: "ds-login-bg", children: /* @__PURE__ */ l("div", { className: "ds-login-card", children: [
    /* @__PURE__ */ l("h1", { className: "ds-login-title", children: [
      /* @__PURE__ */ a("span", { style: { color: "#9ca3af", fontWeight: 400 }, children: "Neutheria " }),
      n
    ] }),
    /* @__PURE__ */ a("div", { className: "ds-login-divider" }),
    e ? /* @__PURE__ */ a("p", { className: "ds-login-tagline", children: e }) : null,
    /* @__PURE__ */ l("div", { className: "ds-login-actions", children: [
      /* @__PURE__ */ a(u, { variant: "primary", block: !0, onClick: s, children: "Sign In" }),
      r ? /* @__PURE__ */ a(u, { variant: "secondary", block: !0, onClick: r, children: "Create Account" }) : null
    ] }),
    /* @__PURE__ */ a("p", { className: "ds-login-footer", children: "Secure authentication provided by Kinde. Your data is encrypted and stored on Cloudflare's global network." })
  ] }) });
}
function j({ className: n, children: e, ...s }) {
  const r = ["ds-card", n ?? ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ a("div", { className: r, ...s, children: e });
}
export {
  u as Button,
  j as Card,
  x as DesignSystemProvider,
  _ as LoginScreen,
  U as Topbar
};
//# sourceMappingURL=index.js.map
